const NoPage = () => {
  return (
    <>
      <h1>404</h1>
      <p>Siden findes ikke</p>
    </>
  );

};

export default NoPage;